import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

import { Observable, throwError } from 'rxjs';
import { Affiliate } from '../_models';
import { BaseResponse, ListResponse } from '../_common';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AffiliateService {
    constructor(private http: HttpClient) { }

    getAffiliate(affiliateId: any): Observable<Affiliate> { //detail
      return this.http.get(`${environment.apiUrl}/keyword/affiliate/find/${affiliateId}`)
      .pipe(
        map((data: BaseResponse) => {
          return new Affiliate().deserialize(data.data);
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    getAll(keywordId: any, filter: any): Observable<ListResponse>  { //listing
      return this.http.post(`${environment.apiUrl}/keyword/affiliate/${keywordId}/list`, JSON.stringify(filter))
      .pipe(
        map((data: ListResponse) => {
          if(data.status == 1 && data.data.list == undefined){
            return null;
          }else{
            return new ListResponse().deserialize(data, Affiliate);
          }
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    addAffiliate(keywordId: any, data): Observable<BaseResponse> {
      return this.http.post(`${environment.apiUrl}/keyword/affiliate/${keywordId}/save`, JSON.stringify(data))
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    updateAffiliate(data): Observable<BaseResponse> {
      return this.http.post(`${environment.apiUrl}/keyword/affiliate/update/${data.id}`, JSON.stringify(data))
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    deleteAffiliate(affiliateId: any): Observable<BaseResponse> {
      return this.http.delete(`${environment.apiUrl}/keyword/affiliate/delete/${affiliateId}`)
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

}
